export const getId = (
  type: 'section' | 'label',
  accordionId: string | undefined,
  key: number | string
): string | undefined =>
  accordionId ? `accordion-${accordionId}-${type}-${key}` : undefined;
